import * as HLF from "html-living-framework";
import {Container} from "../../Core/Container";
import {Sprite} from "../../Core/Sprite";
import {array, Callback, Mix} from "../../Core/Reflection";
import {PuzzleModel} from "./PuzzleModel";
import {texture} from "../../Core/AssetHelpers";
import {Application} from "../../Application";
import {Ease} from "../../Core/Animatable";
import {BaseButton, HoverableButton} from "../../Core/Button";
import {AudioAssets} from "../../Data/Assets";
import {AudioChannel} from "../../Core/AudioChannel";

export class Photo extends Container {

    public readonly image = this.addChild(new Sprite());
    public readonly frames = array(() => this.addChild(new Sprite()));

    public setModel(model: PuzzleModel) {
        this.image.texture = texture(`puzzle-${model.puzzleType}`) || this.image.texture;
        this.frames.forEach((it, i) => it.visible = i + 1 === model.puzzleFrame);
    }
}

export class EditablePhoto extends Photo {

    public button = this.addChild(new (Mix(BaseButton, HoverableButton(1.01)))());
    private selectedFrame = 0;

    onLayout() {
        this.frames.forEach(it => {
            it.changeParent(this.button.visuals);
        });
        this.button.enabled = false;
        this.button.onClick.add(() => {
            this.button.enabled = false;
            this.moveFrameOut(this.frames[this.selectedFrame], () => {
                this.selectedFrame++;
                if (this.selectedFrame >= this.frames.length) {
                    this.selectedFrame = 0;
                }
                this.frames[this.selectedFrame].visible = true;
                this.moveFrameIn(this.frames[this.selectedFrame], () => {
                    this.button.enabled = true;
                });
            });
        });
    }

    hideFrames() {
        this.frames.forEach(it => it.visible = false);
    }

    showFirstFrame() {
        this.selectedFrame = 0;
        this.frames[this.selectedFrame].visible = true;
        this.moveFrameIn(this.frames[this.selectedFrame], () => {
            this.button.enabled = true;
        });
    }

    getSelectedFrame() {
        return this.selectedFrame + 1;
    }

    private moveFrameIn(frame: Sprite, cb?: Callback) {
        AudioChannel.SFX.play(HLF.ArrayUtils.random(AudioAssets.sfx.whoosh).assetName);
        frame.moveYFrom(-Application.instance.size.y - frame.height * 0.5, 0.4, Ease.backOut.config(1.05), cb);
    }

    private moveFrameOut(frame: Sprite, cb?: Callback) {
        const y = frame.y;
        frame.moveYTo(Application.instance.size.y + frame.height * 0.5, 0.15, Ease.sineIn, () => {
            frame.visible = false;
            frame.y = y;
            if (cb) cb();
        });
    }
}